export default __webpack_public_path__ + "static/media/bestListing.c24832a6.png";